<template>
  <div id="student-count" class="chart"></div>
</template>

<script>
import { getStudentByDayApi } from '@/api/school';
import * as echarts from 'echarts'
export default {
  name: 'StudentCount',
  data () {
    return {
      resData: {},
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    }
  }, 
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getStudentByDayApi({ schoolId: this.schoolId }).then(res => {
        this.resData = res.result;
        this.drawLine()
        //setTimeout(this.getData, 000)
      })
    },
    drawLine () {
      let myChart = this.$echarts.init(document.getElementById('student-count'), 'dark')

      let areaColors = [
        ['rgba(128, 255, 165)', 'rgba(1, 191, 236)'],
        ['rgba(0, 221, 255)', 'rgba(77, 119, 255)'],
        ['rgba(55, 162, 255)', 'rgba(116, 21, 219)'],
        ['rgba(255, 0, 135)', 'rgba(135, 0, 157)'],
        ['rgba(255, 191, 0)', 'rgba(224, 62, 76)'],
      ]

      let option = {
        backgroundColor: '',
        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          bottom: 0,
          data: this.resData.legend
        },
        toolbox: {
          feature: {
          }
        },
        grid: {
          top: '3%',
          left: '3%',
          right: '4%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.resData.xAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.resData.series.map((item, index) => {
          return {
            name: item.name,
            type: 'line',
            stack: 'Total',
            smooth: true,
            lineStyle: {
              width: 0
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: areaColors[index][0]
                },
                {
                  offset: 1,
                  color: areaColors[index][1]
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: item.data
          }
        })
      }

      // 绘制图表
      myChart.setOption(option)
    }
  }
}
</script>

<style lang="less">

.chart {
    width: 100%;
    height: 180px !important;
}
</style>
